<template>
    <div class="community_delete">
        <div class="delete" @click="showModal">投稿を削除</div>
        <div class="form" v-if="show">
            <div class="box" v-click-outside="closeModal">
                <div ref="slider" class="contents keen-slider">
                    <div class="complete">
                        <h3>この投稿を削除しますか？</h3>
                        <p>削除すると復活させることはできません。</p>
                        <div class="next">
                            <div class="button" @click="closeModal">削除する</div>
                            <div class="button outlined" @click="closeModal">キャンセル</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vClickOutside from 'click-outside-vue3'
import KeenSlider from 'keen-slider';
export default {
    props: {
        shop: Object
    },
    data() {
        return {
            show: false,
            slide: null,
            index: 0,
        }
    },
    mounted() {
        const content = document.querySelector('.reservation')
        if (content) {
            this.initSlide()
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        showModal() {
            this.show = true;
        },
        closeModal() {
            this.show = false;
        },
        initSlide() {
            const sliderUl = this.$refs.slider
            if (!sliderUl) return
            const childrenArray = Array.from(sliderUl.children)
            this.slide = KeenSlider(this.$refs.slider, {
                initial: this.index,
                slides: {
                    perView: 1
                },
                selector: childrenArray
            })
            this.slide.on('slideChanged', (instance) => {
                const current = instance.track.details.abs
                this.index = current
            })
        },
        async next(number) {
            if (number === 1) {
                this.slide.next('slideChanged', () => {
                    this.index = number
                })
            }
        },
        prev(number) {
            this.slide.prev('slideChanged', () => {
                this.index = number
            })
        },
    },
    watch: {
        show(val) {
            if (!val) return
            this.$nextTick(() => {
                this.initSlide(val)
            })
        }
    }
}
</script>
